export default class SortOptionsMedications {
  column: string;
  name: string;
  dosage: string;
  route: string;
  frequency: string;
  medEntryDate: string;
  orderDate: string;
  converted: string;

  constructor(
    column: string,
    name: string,
    dosage: string,
    route: string,
    frequency: string,
    medEntryDate: string,
    orderDate: string,
    source: string,
    status: string,
    converted: string
  ) {
    this.column = column;
    this.name = name;
    this.dosage = dosage;
    this.route = route;
    this.frequency = frequency;
    this.medEntryDate = medEntryDate;
    this.orderDate = orderDate;
    this.converted = converted;
  }
}



// WEBPACK FOOTER //
// ./src/models/content-wrapper/sort-options-medications.ts